import { motion } from "framer-motion";
import { SectionHeading } from "./Reveal";
import { FlameDivider } from "./motifs";

const CHAPTERS = [
    {
        num: "01",
        title: "Handmade-feeling, richly detailed",
        copy: "Bandhani prints, mirror work, gold embroidery and pearl handles — every piece is chosen for the beautiful, crafted detail that makes a celebration feel special.",
        accent: "#EA580C",
    },
    {
        num: "02",
        title: "Handpicked, never mass-produced",
        copy: "We curate a small, vibrant collection rather than stocking everything. If it's on our page, it's something we'd proudly style our own homes with — and it's perfect for gifting.",
        accent: "#BE123C",
    },
    {
        num: "03",
        title: "Local heart, Australia-wide reach",
        copy: "Pick up your pieces in Point Cook, VIC, or have them delivered anywhere in Australia. Festive warmth, from our home to yours.",
        accent: "#047857",
    },
];

const WhyUs = () => (
    <section id="why" data-testid="why-section" className="relative py-28 sm:py-40 bg-[#472500] text-[#F0EEE8] overflow-hidden">
        <div
            className="absolute inset-0 opacity-[0.05] pointer-events-none"
            style={{
                backgroundImage: "radial-gradient(#E2BA03 1px, transparent 1px)",
                backgroundSize: "34px 34px",
            }}
            aria-hidden="true"
        />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
            <div className="[&_h2]:!text-[#F0EEE8] [&_p]:!text-[#F0EEE8]/50 mb-20 sm:mb-28">
                <SectionHeading
                    eyebrow="Why Choose Festive Theory"
                    title={<>A manifesto of <em className="italic text-[#E2BA03]">heartmade</em> things</>}
                    testId="why-heading"
                />
            </div>
            <div className="flex flex-col">
                {CHAPTERS.map((c, i) => (
                    <motion.div
                        key={c.num}
                        initial={{ y: 56, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.95, delay: 0.05 * i, ease: [0.16, 1, 0.3, 1] }}
                        viewport={{ once: true, margin: "-80px" }}
                        className={`group flex flex-col md:flex-row md:items-baseline gap-4 md:gap-14 py-12 sm:py-16 border-t border-[#F0EEE8]/15 ${
                            i % 2 === 1 ? "md:pl-[12%]" : ""
                        }`}
                        data-testid={`why-chapter-${c.num}`}
                    >
                        <span
                            className="font-display italic text-6xl sm:text-7xl lg:text-8xl leading-none shrink-0 transition-transform duration-500 group-hover:-translate-y-2"
                            style={{ color: c.accent === "#047857" ? "#34D399" : c.accent === "#BE123C" ? "#FB7185" : "#FDBA74" }}
                        >
                            {c.num}
                        </span>
                        <div>
                            <h3 className="font-display text-2xl sm:text-3xl lg:text-4xl leading-snug max-w-xl">
                                {c.title}
                            </h3>
                            <p className="mt-4 text-base sm:text-lg text-[#F0EEE8]/65 leading-relaxed max-w-xl">
                                {c.copy}
                            </p>
                        </div>
                    </motion.div>
                ))}
            </div>
            <div className="mt-16 text-[#E2BA03]">
                <FlameDivider />
            </div>
        </div>
    </section>
);

export default WhyUs;
